/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IntermediaryToDoListViewModel } from './IntermediaryToDoListViewModel';
import {
    IntermediaryToDoListViewModelFromJSON,
    IntermediaryToDoListViewModelFromJSONTyped,
    IntermediaryToDoListViewModelToJSON,
} from './IntermediaryToDoListViewModel';
import type { ResultStates } from './ResultStates';
import {
    ResultStatesFromJSON,
    ResultStatesFromJSONTyped,
    ResultStatesToJSON,
} from './ResultStates';

/**
 * 
 * @export
 * @interface ResultOfIntermediaryToDoListViewModel
 */
export interface ResultOfIntermediaryToDoListViewModel {
    /**
     * 
     * @type {ResultStates}
     * @memberof ResultOfIntermediaryToDoListViewModel
     */
    resultState: ResultStates;
    /**
     * 
     * @type {string}
     * @memberof ResultOfIntermediaryToDoListViewModel
     */
    type?: string;
    /**
     * 
     * @type {number}
     * @memberof ResultOfIntermediaryToDoListViewModel
     */
    status?: number;
    /**
     * 
     * @type {string}
     * @memberof ResultOfIntermediaryToDoListViewModel
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof ResultOfIntermediaryToDoListViewModel
     */
    detail?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResultOfIntermediaryToDoListViewModel
     */
    errors: Array<string>;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ResultOfIntermediaryToDoListViewModel
     */
    validationErrors: { [key: string]: Array<string>; };
    /**
     * 
     * @type {IntermediaryToDoListViewModel}
     * @memberof ResultOfIntermediaryToDoListViewModel
     */
    data?: IntermediaryToDoListViewModel;
    /**
     * 
     * @type {number}
     * @memberof ResultOfIntermediaryToDoListViewModel
     */
    count: number;
}

/**
 * Check if a given object implements the ResultOfIntermediaryToDoListViewModel interface.
 */
export function instanceOfResultOfIntermediaryToDoListViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "resultState" in value;
    isInstance = isInstance && "errors" in value;
    isInstance = isInstance && "validationErrors" in value;
    isInstance = isInstance && "count" in value;

    return isInstance;
}

export function ResultOfIntermediaryToDoListViewModelFromJSON(json: any): ResultOfIntermediaryToDoListViewModel {
    return ResultOfIntermediaryToDoListViewModelFromJSONTyped(json, false);
}

export function ResultOfIntermediaryToDoListViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultOfIntermediaryToDoListViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'resultState': ResultStatesFromJSON(json['ResultState']),
        'type': !exists(json, 'Type') ? undefined : json['Type'],
        'status': !exists(json, 'Status') ? undefined : json['Status'],
        'title': !exists(json, 'Title') ? undefined : json['Title'],
        'detail': !exists(json, 'Detail') ? undefined : json['Detail'],
        'errors': json['Errors'],
        'validationErrors': json['ValidationErrors'],
        'data': !exists(json, 'Data') ? undefined : IntermediaryToDoListViewModelFromJSON(json['Data']),
        'count': json['Count'],
    };
}

export function ResultOfIntermediaryToDoListViewModelToJSON(value?: ResultOfIntermediaryToDoListViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ResultState': ResultStatesToJSON(value.resultState),
        'Type': value.type,
        'Status': value.status,
        'Title': value.title,
        'Detail': value.detail,
        'Errors': value.errors,
        'ValidationErrors': value.validationErrors,
        'Data': IntermediaryToDoListViewModelToJSON(value.data),
        'Count': value.count,
    };
}

